var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"color_wrapper"},_vm._l((_vm.colors),function(item){return _c('li',{key:item.value,staticClass:"color_item Disp_AC AkrobatM"},[_c('em',{style:({background: item.color})}),_vm._v(" "+_vm._s(item.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }